import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { DateCell } from "~/components/cells/DateCell.tsx"
import { DocumentActionsCell } from "~/components/cells/DocumentActionsCell"
import { ExportRequestResponseDto } from "~/gen/api"
import { ExportStatusBadge } from "~/pages/Brand/DataTransfer/Export/ExportStatusBadge"

const columnHelper = createColumnHelper<ExportRequestResponseDto>()
export const useColumns = () => {
  const { t } = useTranslation("dataTransfer")

  return useMemo<ColumnDef<ExportRequestResponseDto, any>[]>(
    () => [
      columnHelper.accessor("exportConfiguration.name", {
        header: t("columns.name"),
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor("createdAt", {
        header: t("columns.launchedAt"),
        cell: (info) => <DateCell date={info.getValue()} format="lll" />,
      }),
      columnHelper.accessor("exportReport.total", {
        header: t("columns.rowsCount"),
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor("status", {
        header: t("columns.status"),
        cell: (info) => <ExportStatusBadge status={info.getValue()} />,
      }),
      columnHelper.display({
        header: t("columns.document"),
        cell: (info) => {
          const { document } = info.row.original

          return document ? (
            <DocumentActionsCell
              documentId={document.id}
              documentName={document.originalName}
              filename={document.originalName ?? undefined}
              canView={false}
              canDownload
            />
          ) : null
        },
      }),
    ],
    [t]
  )
}
